<div class="container mobile-padding pt-zetta pt-xl-200">
  <h3 class="text-light-gray offset-2 col-10">{{ header }}</h3>
  <div class="pt-giga pt-xl-exa">
    <ng-content></ng-content>
  </div>
</div>
